import { Component, OnInit } from '@angular/core';
import { RegionWiseChartHandler } from './region-channel-wise-chart.handler.';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'sym-region-chart',
  templateUrl: './region-channel-wise-chart.component.html',
  styleUrls: ['./region-channel-wise-chart.component.scss'],
})
export class RegionWiseChartComponent extends RegionWiseChartHandler {
  constructor(public service: DashboardService, public settingService: SettingService) {
    super(service, settingService);
  }
}
